export default {
  wrapper: {
    marginLeft: '25px',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    position: 'relative',
    '& + *': {
      marginLeft: '12px',
    },
  },

  contentContainer: {
    display: 'flex',
    width: '300px',
    minHeight: '50px',
    transitionProperty: 'opacity',
    transitionDuration: '.2s',
    transitionTimingFunction: 'ease',
    position: 'absolute',
    bottom: '0',
    right: '12px',
    backgroundColor: '#FFF',
    border: '1px solid hsla(0, 0%, 0%, 0.2)',
    borderTop: 'none',
    transform: 'translate(0, 100%)',
    visibility: 'hidden',
    opacity: '0',
    flexDirection: 'column',
    '&.active': {
      opacity: '1',
      visibility: 'visible',
    },
  },

  hint: {
    margin: 'auto',
    color: 'hsla(0, 0%, 0%, 0.5)',
  },
}
